
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";

const base = namespace("base");
const service = namespace("service");
@Component({})
export default class ShangHaiPrint extends Vue {
  @base.Action getDictionaryList;
  @service.Action getCarSettlementList;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  checked = false;
  shanghaiPrintData: any = {};
  @Prop({ type: String, default: "" })
  orderNo: String;
  //计算属性
  get breadData() {
    return [];
  }
  settlementPriceTable = [
    {
      money: "-",
      name: "工时费",
      remark: "-"
    },
    {
      money: "-",
      name: "材料费",
      remark: "-"
    },
    {
      money: "0",
      name: "外加工费",
      remark: "-"
    },
    {
      money: "-",
      name: "其他",
      remark: "-"
    },
    {
      money: "-",
      name: "优惠金额",
      remark: "-"
    },
    {
      money: "-",
      name: "合计",
      remark: "-"
    }
  ];
  manHourCost: any = [];
  materials: any = [];
  created() {
    this.init();
  }

  async init() {
    let res = await this.getCarSettlementList({ orderNo: this.orderNo });
    console.log("[ res ]", res);
    this.shanghaiPrintData = res.data;
    console.log("[ this.shanghaiPrintData ]", this.shanghaiPrintData);
    // 一、结算价格(单位: 元)
    this.settlementPriceTable[0].money = emptyToLine(
      res.data.workingHoursAmount,
      splitThousands(res.data.workingHoursAmount)
    );
    this.settlementPriceTable[1].money = emptyToLine(res.data.materialAmount, splitThousands(res.data.materialAmount));
    this.settlementPriceTable[3].money = emptyToLine(res.data.additionalFees, splitThousands(res.data.additionalFees));
    this.settlementPriceTable[3].remark = emptyToLine(res.data.additionalFeesRemark);
    this.settlementPriceTable[4].money = emptyToLine(res.data.discountAmount, splitThousands(res.data.discountAmount));
    this.settlementPriceTable[5].money = emptyToLine(res.data.payAmount, splitThousands(res.data.payAmount));
    // 二、工时费(单位: 元)
    this.manHourCost = res.data.serviceDetail;
    this.manHourCost.push({
      amount: res.data.serviceDetail
        .reduce((total, item) => {
          return total + Number(item.amount);
        }, 0)
        .i18nToFixed(),
      serviceName: "合计："
    });

    // 三、材料费(单位: 元)
    this.materials = res.data.partsDetail;
    this.materials.push({
      amount: res.data.partsDetail
        .reduce((total, item) => {
          return total + Number(item.amount);
        }, 0)
        .i18nToFixed(),
      partsName: "合计："
    });
  }
}
